import likeIcon from '@/assets/img/pennant/like.png'
import pennantIcon from '@/assets/img/pennant/pennant.png'
import letterIcon from '@/assets/img/pennant/letterIcon.png'
import likebg from '@/assets/img/pennant/likebg.png'
import like_active from '@/assets/img/pennant/like_active.png'
import ascend from '@/assets/img/pennant/ascend.png'
import defaultSort from '@/assets/img/pennant/defaultSort.png'
import descend from '@/assets/img/pennant/descend.png'
import patientBg from '@/assets/img/pennant/patientbg.png'
import likeHeader from '@/assets/img/pennant/likeHeader.png'
import { getMoment } from '@/utils/index.js'

const drawerWrapStyle = {
  background: '#F3F7FA'
}
const drawerBodyStyle = {
  background: `url(${likebg})`,
  backgroundSize: '100% 275px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top',
  padding: '0px'
}
const headerStyle = {
  background: `url(${likeHeader})`,
  backgroundSize: '100% 55px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top',
  borderBottom: '1px solid #00000017'
}
const activeStyle = {
  backgroundImage: `url(${like_active})`,
  backgroundSize: '100% 100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  height: '65px'
}
const patientBgStyle = {
  backgroundImage: `url(${patientBg})`,
  backgroundSize: '100% 220px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top'
}
const defaultFeedbackTypeMap = [
  {
    label: '累计点赞',
    value: 1,
    key: 'doctorLikeNum',
    num: 0,
    currentText: '最近一次点赞：'
  },
  {
    label: '累计锦旗',
    value: 2,
    key: 'doctorPennantNum',
    num: 0,
    currentText: '最近一次送锦旗：'
  },
  {
    label: '累计感谢信',
    value: 3,
    key: 'thankLettersNum',
    num: 0,
    currentText: '最近一次写感谢信：'
  },
  {
    label: '患者满意度',
    value: 4,
    key: 'satisfaction',
    num: 0
  }
]
const praiseItems = [
  {
    label: '点赞',
    value: 1,
    key: 'likeAllTimeNum',
    icon: likeIcon,
    style: {
      color: '#EB3C59',
      backgroundColor: '#FFF5F4'
    }
  },
  {
    label: '锦旗',
    value: 2,
    key: 'pennantAllTimeNum',
    icon: pennantIcon,
    style: {
      color: '#D44F2F',
      backgroundColor: '#FFF7ED'
    }
  },
  {
    label: '感谢信',
    value: 3,
    key: 'thankLettersAllTimeNum',
    icon: letterIcon,
    style: {
      color: '#A8675E',
      backgroundColor: '#FFF6F3'
    }
  }
]
// 审核枚举
const auditStatusMap = [
  {
    label: '待审核',
    value: 0,
    style: {
      borderColor: '#6666664d',
      color: '#666666'
    }
  },
  {
    label: '审核通过',
    value: 1,
    style: {
      borderColor: '#00b2874d',
      color: '#00b287'
    }
  },
  {
    label: '审核不通过',
    value: 2,
    style: {
      borderColor: '#f459594d',
      color: '#f45959'
    }
  },
  {
    label: '精选',
    value: 3,
    style: {
      color: '#ff8926',
      borderColor: '#ff89264d'
    }
  }
]
// 来源
const sourceTypeMap = [
  {
    label: '系统自填',
    value: 1
  },
  {
    label: '患者填写',
    value: 2
  },
  {
    label: '医助代填',
    value: 3
  }
]
// 格式化输入内容
const formatContent = content => {
  if (!content) {
    return []
  }
  return content.split('\n')
}
const sortMap = [
  {
    label: '默认排序',
    value: 0,
    icon: defaultSort
  },
  {
    label: '倒序',
    value: 2,
    icon: ascend
  },
  {
    label: '正序',
    value: 1,
    icon: descend
  }
]
const rangePresets = {
  今日: getMoment(1),
  本月: getMoment(2),
  上月: getMoment(3),
  近三月: getMoment(4)
}
export {
  drawerWrapStyle,
  drawerBodyStyle,
  headerStyle,
  activeStyle,
  defaultFeedbackTypeMap,
  praiseItems,
  auditStatusMap,
  sourceTypeMap,
  like_active,
  patientBgStyle,
  formatContent,
  sortMap,
  rangePresets
}
